/* CHAOSRXOptics: keep the Klaviyo "$10 OFF" teaser out of the hero and off sticky CTA bars. 2026-09-28.
   Adds html.cx-kl-ok once the visitor has scrolled past the hero (on the homepage: past the hero plus the
   "Buying for a crew?" band; 60% of a screen on pages without a hero),
   and sets --cx-kl-lift so the teaser sits above any full-width bar fixed at (or floating near) the bottom of the viewport.
   Pair: assets/cx-type-floor-rx.css. Rollback: remove the script tag in layout/theme.liquid. */
(function () {
  var root = document.documentElement;
  var HERO = '.cxv4 .hero, .cxb3-hero, .cxb3-ad-hero, .rxv-hero, main .banner, main section:first-of-type';
  var BARS = '.cxb3-mobile-convert, [class*="sticky-buy"], [class*="sticky-bar"], [class*="mobile-cta"], [class*="sticky-cta"]';
  var ticking = false;

  function threshold() {
    var hero = document.querySelector('.cx-crew') || document.querySelector(HERO);
    if (hero) {
      var r = hero.getBoundingClientRect();
      if (r.height > 120) return r.bottom + window.scrollY - window.innerHeight * 0.35;
    }
    return window.innerHeight * 0.6;
  }

  function lift() {
    var max = 0, vh = window.innerHeight, vw = window.innerWidth;
    var bars = document.querySelectorAll(BARS);
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i], cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity < 0.1) continue;
      var r = el.getBoundingClientRect();
      if (r.width < vw * 0.5 || r.height < 1 || r.bottom < vh - 160 || r.top > vh) continue;
      max = Math.max(max, Math.ceil(vh - r.top) + 8);
    }
    root.style.setProperty('--cx-kl-lift', max + 'px');
  }

  function update() {
    ticking = false;
    root.classList.toggle('cx-kl-ok', window.scrollY > Math.max(0, threshold()));
    lift();
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();
